import React from 'react';
import { ImageOff } from 'lucide-react';

/** Compact product tile: image on a neutral well, name below (max two lines). */
export default function ProductCard({ product }) {
    return (
        <div className="w-40 shrink-0 flex flex-col rounded-xl border border-surface-200 bg-white p-2">
            <div className="h-32 md:h-36 w-full flex items-center justify-center rounded-lg bg-surface-50 p-2">
                {product?.images ? (
                    <img alt={product?.name || ''} src={product?.images} className="w-full h-full object-contain" loading="lazy" />
                ) : (
                    <ImageOff className="text-[22px] text-surface-300" />
                )}
            </div>
            <p className="m-0 mt-2 px-1 pb-1 text-center text-xs leading-snug text-surface-700 line-clamp-2" title={product?.name}>
                {product?.name}
            </p>
        </div>
    );
}
